import { Component, OnInit, Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountService } from 'src/app/services/account.service';

@Component({
  selector: 'app-delete-branch',
  templateUrl: './delete-branch.component.html',
  styleUrls: ['./delete-branch.component.css']
})
export class DeleteBranchComponent implements OnInit {
  branchId: any;
  loading: boolean;
  api_success: any;
  api_error: any;
  corpId: any;

  constructor(private matDialogRef: MatDialogRef<any>, @Inject(MAT_DIALOG_DATA) public data: any,
  private accountService: AccountService) { }

  ngOnInit() {
    this.branchId = this.data['branchId'];
    this.corpId  = this.data['corpId'];
  }
  onDeleteConfirm() {
    this.loading = true;
    const filter = 'corpId-eq='  + this.corpId  + '&branchId-eq=' + this.branchId  + '&accountType-eq=BRANCH' ;
    this.accountService.deleteBranch(filter)
  .subscribe(
    data => {
      this.loading = false;
      this.api_success = 'Branch deletion is successfully initated, you will receive an email after deletion';

      setTimeout(() => {
        this.matDialogRef.close('reloadlist');
        }, 2000);
      },
   (error) => {
     this.loading = false;
    this.api_error = error.error;
    }
  );

  }

}
